import { creamTokens } from "../design-system/creamDesignSystem";

export const BRAND_LOGO = "/brand/cream-creations-logo.jpeg";
export const TOK = creamTokens;
export const C = {
  primary: TOK.color.rose, soft: TOK.color.roseSoft, secondary: TOK.color.roseDeep, accent: "#F0A7BA",
  bg: TOK.color.cream, surface: TOK.color.surface, border: TOK.color.line, borderMid: TOK.color.lineStrong,
  text: TOK.color.ink, mid: TOK.color.muted, light: "#BCAAA2", chocolate: TOK.color.chocolate,
  success: TOK.color.success, warning: TOK.color.warning, danger: TOK.color.critical, info: TOK.color.info, purple: TOK.color.violet,
  STATUS: {
    CONFIRMED:        { bg: "#E8F0FB", fg: "#1A5FA8",  label: "Confirmed"        },
    IN_PRODUCTION:    { bg: "#FEF3E2", fg: "#C07B10",  label: "In Production"    },
    READY:            { bg: "#E6F5EC", fg: "#257C48",  label: "Ready"            },
    OUT_FOR_DELIVERY: { bg: "#F0EAF8", fg: "#6B35A8",  label: "Out for Delivery" },
    DELIVERED:        { bg: "#F5F5F5", fg: "#5A5A5A",  label: "Delivered"        },
    COLLECTED:        { bg: "#F5F5F5", fg: "#5A5A5A",  label: "Collected"        },
    DELIVERY_FAILED:  { bg: "#FDEAEA", fg: "#C42C2C",  label: "Failed"           },
    CANCELLED:        { bg: "#F8F8F8", fg: "#A0A0A0",  label: "Cancelled"        },
    FLAGGED:          { bg: "#FDEAEA", fg: "#C42C2C",  label: "Flagged"          },
    PENDING_APPROVAL: { bg: "#FFF8E6", fg: "#C07B10",  label: "Pending Approval" },
    DRAFT:            { bg: "#F5F5F5", fg: "#9E9E9E",  label: "Draft"            },
    NEW:              { bg: "#E8F0FB", fg: "#6E7FD8",  label: "New"              },
    CONTACTED:        { bg: "#F8DDE6", fg: "#B94F72",  label: "Contacted"        },
    QUOTED:           { bg: "#FFF8E6", fg: "#E5A93D",  label: "Quoted"           },
    CONVERTED:        { bg: "#E6F5EC", fg: "#1F9D6A",  label: "Converted"        },
    LOST:             { bg: "#FDEAEA", fg: "#E25555",  label: "Lost"             },
    REOPENED:         { bg: "#F0EAF8", fg: "#8C6AD9",  label: "Reopened"         },
  } as Record<string, { bg: string; fg: string; label: string }>,
};

export const EXECUTIVE_ROLES = ["OWNER", "MASTER_ADMIN", "SUPER_ADMIN"];
export const MANAGER_ROLES = ["OPERATIONS_MANAGER", "SALES_MANAGER"];
export const SALES_ROLES = ["OWNER", "MASTER_ADMIN", "SUPER_ADMIN", "OPERATIONS_MANAGER", "SALES_MANAGER", "SALES"];
export const OPS_ROLES = ["OWNER", "MASTER_ADMIN", "SUPER_ADMIN", "OPERATIONS_MANAGER"];
export const ADMIN_ROLES = ["OWNER", "MASTER_ADMIN", "SUPER_ADMIN"];
export const WHATSAPP_ROLES = ["OWNER", "MASTER_ADMIN", "SUPER_ADMIN", "OPERATIONS_MANAGER", "SALES_MANAGER", "SALES"];
export const FOLLOW_UP_ROLES = ["OWNER", "MASTER_ADMIN", "SUPER_ADMIN", "OPERATIONS_MANAGER", "SALES_MANAGER", "SALES"];
export const ROLE_LABELS: Record<string, string> = {
  OWNER: "Owner",
  MASTER_ADMIN: "Master Admin",
  SUPER_ADMIN: "System Admin",
  OPERATIONS_MANAGER: "Operations Manager",
  SALES_MANAGER: "Sales Manager",
  SALES: "Sales Teammate",
  PRODUCTION: "Production Teammate",
  DELIVERY: "Dispatch Teammate",
  ACCOUNTS: "Finance Teammate",
  MARKETING: "Marketing Teammate",
};
export const roleLabel = (role = "") => ROLE_LABELS[role] || role.replace(/_/g, " ");
export const hasAnyRole = (role: string, roles: string[]) => roles.includes(role);
export const urgColor = (d: string) => { const n = (new Date(d).getTime() - Date.now()) / 86400000; return n <= 0 ? C.danger : n <= 1 ? C.warning : n <= 3 ? "#C07B10" : C.success; };
export const urgLabel = (d: string) => { const n = (new Date(d).getTime() - Date.now()) / 86400000; return n <= 0 ? "OVERDUE" : n < 1 ? "TODAY" : n < 2 ? "TMRW" : `${Math.floor(n)}d`; };
